"use client";
import { LicenseInfo } from "@mui/x-license";

LicenseInfo.setLicenseKey(
  "9ee49558b9c2dbedfa91cc87fb249d7aTz0xMTI5OTgsRT0xNzgwODc2Nzk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y",
);

export default function MuiXLicense() {
  return null;
}
